// src/index.js

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';  // Your custom CSS (if any)
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css'; // Importing Bootstrap CSS

if (process.env.NODE_ENV === 'development') {
  import('react-grab');
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
